import { get, post } from "./request.js";

// 获取稿件详情
export function previewArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/plusDetail/${id}`)
    .then((res) => res.data)
    .catch((e) => e);
}

// 花城+获取稿件
export function getPlusArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/plusDetail/${id}`)
    .then((res) => res.data)
    .catch((e) => e);
}

// 花城FM获取稿件
export function getHcfmArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/hcfmDetail/${id}`)
    .then((res) => res.data)
    .catch((e) => e);
}

// GSCB获取稿件
export function getGscbArticle(id) {
  return get(`/gzbn-cloud-manuscript-app/app/article/detail/${id}`)
    .then((res) => res.data)
    .catch((e) => e);
}

// 花城+根据operacteId查询评论
export function queryAllComments(params) {
  return get(`/media-cloud-interact-app/comments/queryAllComments`, params)
    .then((res) => res.data)
    .catch((e) => e);
}

export function getCookie(params) {
  // return request(`/gzbn-auth/auth/getCookie`, params, { withCredentials: true });
  return get(`/gzbn-auth/auth/getCookie`, params, { withCredentials: true })
    .then(res => res)
    .catch(e => e);
}

export function clickRecord(params) {
  return get(`/media-cloud-interact-app/clickAndShare/clickRecord`, params)
    .then(res => res.data)
    .catch(e => e);
}

export function queryOperateBtn(params) {
  return get(`/media-cloud-interact-app/tagBtnRecord/queryOperateBtn`, params)
    .then(res => res.data)
    .catch(e => e);
}